<template>
  <button 
    style="position: relative"
    :class="onMobile ? 'button-wrapper-mobile' : 'button-wrapper'" 
    :style="setWrapperStyle()" 
    @click="$emit('select')"
  >
    <InfoButton 
      v-if="data.infobox && data.infoboxOnline"
      minimized="true"
      @showspecs="infoboxID = data.infobox; enableAndHoldSpecs();"
    />
    <div class="card" :class="selected ? 'card-selected' : '' ">
      <div class="card-header">
        <img :src="`${previewsServer + models}previews/${data.code}.png`" alt="" @error="setBackupImage($event, data)">
      </div>
      <div class="card-info">
        <h3>{{ data.shortName }}</h3>
      </div>
    </div>
  </button>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcoverForOptionCard"
        tabindex="-1"
        @click="specsVisible = false"
        @keydown.escape="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
          <button 
            class="modalclosebutton" 
            @mouseover="specsCloseBtnMouseOver" 
            @mouseleave="specsCloseBtnMouseLeave"
            @click="specsVisible = false"
          >
            <Transition name="closebtn">
              <div 
                v-show="hasGlowingCloseBtn"
                class="absolutepos glowingclose"
              />
            </Transition>
            <div>
              ×
            </div>
          </button>
          <div class="imagescroller">
            <img 
              class="modalimage" 
              :src="`/infoboximages/${getFullInfoboxData?.urlEnding}`" 
              alt=""
            >
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { mapGetters } from 'vuex';
import InfoButton from '@/components/inputs/buttons/InfoButton.vue'
  export default {
    name: "OptionCard",
    components: {
      InfoButton
    },
    props: {
      data: Object,
      selected: Boolean,
      hasAutomargin: {
        type: Boolean,
        default: true
      },
      hasWidthlimit: {
        type: Boolean,
        default: true
      },
    },

    data () {
      return {
        models: import.meta.env.VITE_VUE_APP_MODELS_LOCATION,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        onMobile: false,
        specsVisible: false,
        hasGlowingCloseBtn: false,
        infoboxID: null
      }
    },
    computed: {
      ...mapGetters({
        infoboxes: 'getInfoboxes'
      }),

      getFullInfoboxData() {
        return this.infoboxes.find(info => info.id === this.infoboxID)
      }
    },

    created() {
      let regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      this.onMobile = regex.test(navigator.userAgent)
      this.$nextTick(() => {
          document.getElementById('fullcoverForOptionCard')
            .addEventListener('click', function (/*event*/) {
                // console.log('TEST',event)
            });
        })
    },

    methods: {
      setBackupImage(e, data) {
        e.target.src = `https://fakeimg.pl/400x400/?text=${data.code +  (data.options.length > 0 ? data.options[this.selectedOption].subCode : '')}&font=bebas`
      },
      setWrapperStyle() {
        return `${this.hasAutomargin ? '' : 'margin: 0px;'}${this.hasWidthlimit ? '' : 'max-width: none; width: 100%;'}`
      },

      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
        if (this.specsVisible) {
          this.$nextTick(() => {
            document.getElementById('fullcoverForOptionCard')?.focus();
          });
        }
      }
    },
      
  }
</script>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 20px);
  flex-direction: column;
  outline: 3px solid $c-border-1;
  border-radius: $radius-m;
  padding: 10px;
  transition: outline-color 100ms ease;
  border: none;
  background-color: transparent;
  scroll-margin: 150px;

  &:hover {
    outline-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    outline-color: $c-secondary;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    height: 150px;

    & img {
      min-height: 150px;
      max-height: 150px;
      width: 100%;
      object-fit: contain;
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & h3 {
      font-size: 1rem;
      text-align: left;
      margin: 0px;
    }
  }
}

#fullcoverForOptionCard {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  left: 50%;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}

.imagescroller {
  max-height: calc(98%);
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

.glowingclose {
  border-radius: 20px;
}

.button-wrapper {
  border: none;
  display: flex;
  margin: auto;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  max-width: 16.5rem;
  height: 15.5rem;
}

.button-wrapper-mobile {
  border: none;
  display: flex;
  margin: auto;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  width: 93vw;
  height: 14rem;
}

</style>